<script setup lang="ts">
import { LINKS } from '@/utils/constants'

const { colors } = useTheme()
</script>

<template>
  <div>
    <NuxtLink :to="LINKS.magicPage" relative w-full h-12 center gap-3 hidden class="!md:center group">
      <div absolute top-0 bottom-0 left-0 right-0 z-0 duration-125 opacity-75 group-hover:opacity-85 :class="$style.gradient" />
      <img absolute top-0 right-0 h-full src="@/assets/images/BannerBackground.png">

      <div flex gap-1>
        <Text variant="large" :color="colors.primary" relative z-1 class="!" style="font-weight: 500 !important;">
          New!
        </Text>
        <Text variant="large" color="white" relative z-1 class="!" style="font-weight: 500 !important;">
          Never type a prompt or text again. Download our Magic Keys plugin
        </Text>
      </div>

      <div center isolate z-1>
        <div i-logos:chrome text="22px" z-1 m="r-[-4px]" />
        <IconMagic :colored="false" />
      </div>
    </NuxtLink>
  </div>
</template>

<style module>
.gradient {
  background-color: #5824FB;
  /* background: url(), lightgray 0% 0% / 100px 100px repeat, rgba(88, 36, 251, 0.75); */
  background-blend-mode: overlay, normal;
}
</style>
